const API = process.env.AZURE_FUNCTIONS_API || '/api'
const API_APP_KEY = process.env.API_APP_KEY || process.env.GATSBY_API_APP_KEY

export {API as default, API_APP_KEY}
